import React from "react";
import { Icon, Slider, Collapse, Button } from "@blueprintjs/core";
import { Translate} from "react-redux-i18n";
import CreateGroupForm from "./CreateGroupForm";
import CircleImage from "../../components/Image/CircleImage";
import FormatedPrice from "../../components/FormatedPrice";
import LoadingIndicator from "../../components/LoadingIndicator";
import { connect } from "react-redux";
import { register } from "../../store/iam/operations";
import { navigate } from "../../store/navigation/operations";
import ReactGA from "react-ga";
import { saveCircle, inviteFriends } from "../../store/my_circles/operations";
import { loggedInUserGuid } from "../../store/iam/selectors";
import { savingCircle, invitingFriends } from "../../store/my_circles/selectors";
import { updateProduct, previousPage, nextPage, saveNewCircleDetails } from "../../store/b2b_button/creators";
import { getB2BProduct, groupeType, getCreatedCircle } from "../../store/b2b_button/selectors";
import Div100vh from "react-div-100vh";

class Page3 extends React.Component{
    state = {
        isOpen: false,
    };

    submitButtonRef=React.createRef();
    submitForm=()=>{
        this.submitButtonRef.current.buttonRef.click();
    }

    toggleProductInfo = () => this.setState({ isOpen: !this.state.isOpen });

    circle_form = {
        name: "",
        max_owners_no: "2",
        description: "",
        created_by: "",
        products: [
          {
            name: "",
            url: "",
            base64_image: "",
            currency: "SEK",
            price: "",
            pre_owned: false,
          }
        ],
        address: "",
        lat: "",
        lon: "",
        country: "",
        city: "",
        labels: [],
        tags: [],
        is_public: true,
        has_agreement: true
    };

    changeMembersNumber=(value)=>{
        this.props.updateProduct({suggested_members_no: value});
    }

    onRegister=(values)=>{
        this.handleSubmit(values).then(_=>{
            this.saveCircle(values).then(response=>{
                if(response){
                    this.props.saveNewCircleDetails(response);
                }
                if(values.friends){
                    this.sendInvitationToFriends(values.friends).then(_=>{
                        this.props.nextPage();
                    })
                }else{
                    this.props.nextPage();
                }
            })
        })
    }

    handleSubmit(values) {
        ReactGA.event({
          category: "User",
          action: "Created an Account"
        });

        const payload = {
            u_name: values.user_name.toLowerCase(),
            email: values.user_name,
            f_name: values.first_name,
            l_name: values.last_name,
            locale: this.props.locale,
            pw: values.password
          }

       return this.props.register(payload)         
    }

    saveCircle = circle_details => {        
        const payload = this.createPayload(circle_details);
        return this.props.saveCircle(payload, null, false);
    };

    createPayload=(circle_details)=>{
        const product = this.props.product;
        this.circle_form={
            ...this.circle_form,
            description: product.short_description,
            name: product.name,
            is_public: this.props.groupe_type==="public"?true:false,
            products: [
                {...this.circle_form.products[0], 
                    price: product.total_price.toString(), 
                    url: product.product_url,
                    image_url: product.images[0].url,
                    name: product.name
                }],
            address: circle_details.address,
            lat: circle_details.lat.toString(),
            lon: circle_details.lon.toString(),
            country: circle_details.country,
            city: circle_details.city,
            created_by: this.props.myGuid,
            max_owners_no: circle_details.max_owners_no
        } 
        return this.circle_form;
    }
    
    sendInvitationToFriends=(friends)=>{
        const invitations = Object.values(friends).map((friend=>{
            const channel = 'email' in friend?'email':'sms';
            return {
                locale: this.props.locale,
                channel: channel,
                receiver: friend[channel]
            }
        }))
        const circle_guid = this.props.new_circle.guid;
        return this.props.inviteFriends(circle_guid, invitations); 
    }

    render(){
        const {product, previousPage} = this.props;
        const isLoading = this.props.registering || this.props.creating_circle || this.props.inviting_friends; 
        return(
            <Div100vh className="b2b-100vh-container">
                <div className="b2b-container">
                    <div className="back-button" onClick={_=>previousPage()}>
                        <Icon icon="arrow-left" className="icon" />
                        <Translate value="b2b.go_back" />
                    </div>
                    <div className="main-content-wrapper">
                        <div className="product-info trigger-collapse" onClick={this.toggleProductInfo}>
                            <div className="product-image">
                                <CircleImage src={product.images[0].url} size="medium" alt={product.name} />
                            </div>
                            <div className="product-meta">
                                <div className="product-name">
                                    {product.name}
                                </div>
                                <div className="product-meta-helper">
                                    <Translate value="b2b.members_no_helper" 
                                        members_no={product.suggested_members_no} 
                                    />
                                    <FormatedPrice
                                        value={parseFloat(product.total_price) / parseInt(product.suggested_members_no)}
                                        currency_type={product.currency}
                                    /> 
                                    <Translate value="b2b.change_members_no" />                                     
                                </div>
                            </div>
                        </div>
                        <Collapse isOpen={this.state.isOpen} className="co-owner-collapse">
                            <div className="product-owner-split">
                                <div className="owner-split">
                                    <div className="owner-split-item owner-info">
                                        <div className="number">
                                            {product.suggested_members_no}
                                        </div>
                                        <div className="label">
                                            <Translate value="b2b.co_owners" />                                    
                                        </div>
                                    </div>
                                    <div className="owner-split-item price-info">
                                        <div className="previous-number">
                                            {product.total_price}
                                        </div>
                                        <div className="number">
                                            <FormatedPrice
                                                value={parseFloat(product.total_price) / parseInt(product.suggested_members_no)}
                                                currency_type={product.currency}
                                            />                                     
                                        </div>
                                        <div className="label">
                                            <Translate value="b2b.per_owner" />                                      
                                        </div>
                                    </div>
                                </div>
                                <Slider
                                    min={2}
                                    max={100}
                                    stepSize={1}
                                    labelStepSize={5}
                                    labelRenderer={true}
                                    value={product.suggested_members_no}
                                    showTrackFill={true}
                                    onChange={this.changeMembersNumber}
                                    className="product-slider"
                                />
                                <hr />
                            </div>
                        </Collapse>
                    
                        <CreateGroupForm 
                            product={this.props.product}
                            onRegister={this.onRegister} 
                            isLoading={isLoading} 
                            private_group={this.props.groupe_type==="private"}
                            sendInvitationToFriends={this.sendInvitationToFriends}
                            updateOwnersNumber={this.changeMembersNumber}
                            submitRef={this.submitButtonRef} 
                        />   
                    </div>
                    <div className="cta-area">
                        {isLoading && <LoadingIndicator />}
                        {!isLoading && (
                        <>
                            <Button
                                disabled={isLoading}
                                className="register-button"
                                intent="primary"
                                fill={true}
                                type="button"
                                onClick={this.submitForm}
                            >
                                <Translate value="b2b.create_group" />                
                            </Button>
                            <div className="cta-helper-text">
                                <Translate value="b2b.non_binding" />                        
                            </div>
                        </>
                        )}
                    </div>
                </div>
            </Div100vh>          
        )
    }
}

const mapStateToProps = state => ({
    locale: state.i18n.locale,
    registering: state.iam.loading,
    creating_circle: savingCircle(state),
    new_circle: getCreatedCircle(state),
    myGuid: loggedInUserGuid(state),
    inviting_friends: invitingFriends(state),
    product: getB2BProduct(state),
    groupe_type: groupeType(state)
  });
  const mapDispatchToProps ={
    navigate,
    register,
    saveCircle,
    inviteFriends,
    previousPage,
    nextPage,
    updateProduct,
    saveNewCircleDetails
  }  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Page3);
